module.exports = __webpack_public_path__ + "img/arrow-square-up-left.149a27dd.svg";